import { FC } from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import { useAuth } from 'store/auth/useAuth'
import useMedcoinData from 'store/common/useMedcoinData'

import { IMedcoinData } from 'store/data-types'
import { WatchStatus } from 'constants/webinar-data'
import { MaterialTypes, STATIC_URL, TypeCodes } from 'constants/data'

import styles from './card-bonus.module.scss'

interface ICardBonus {
  status?: WatchStatus
  materialType?: MaterialTypes
  ArticleTypeId?: number
  pointsNMO?: number
  modificatorWrap?: string
}

const defineValue = (
  medcoins: IMedcoinData,
  materialType?: MaterialTypes,
  ArticleTypeId?: number,
  pointsNMO?: number
) => {
  if (materialType === MaterialTypes.FUTURE_WEBINAR) return medcoins?.webinarActive?.quantity || 0
  if (materialType === MaterialTypes.WEBINAR) return medcoins?.webinarRecord?.quantity || 0
  if (materialType === MaterialTypes.NMO && pointsNMO === 18) return medcoins?.nmo18?.quantity || 0
  if (materialType === MaterialTypes.NMO && pointsNMO === 36) return medcoins?.nmo36?.quantity || 0
  if (materialType === MaterialTypes.NMO && pointsNMO === 36) return medcoins?.nmo144?.quantity || 0
  if (ArticleTypeId === TypeCodes.VIDEO) return medcoins?.videoWatch?.quantity || 0
  if (ArticleTypeId === TypeCodes.ARTICLE) return medcoins?.articleRead?.quantity || 0

  return 0
}

const CardBonus: FC<ICardBonus> = ({
  status,
  materialType,
  ArticleTypeId,
  pointsNMO,
  modificatorWrap,
}) => {
  const { isNotAuthorized } = useAuth()
  const { medcoinData } = useMedcoinData()

  if (isNotAuthorized) return null
  if (status === WatchStatus.FINISH) return null

  const value = defineValue(medcoinData, materialType, ArticleTypeId, pointsNMO)
  if (!value) return null

  return (
    <div
      className={clsx(styles.wrap, {
        [modificatorWrap as string]: modificatorWrap,
      })}
    >
      <Image src={`${STATIC_URL}/game/coin.svg`} alt={'Медкоин'} width={16} height={16} />
      <span className={styles.text}>{value}</span>
    </div>
  )
}

export default CardBonus
